/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */
import {Component, OnInit} from '@angular/core';

import {takeUntil, tap} from 'rxjs/operators';

import {AsideUtilsService} from './aside-utils.service';

import {Destroyable} from '../../destroyable.component';
import {ApiService} from '../../shared/api/api.service';
import {RolesService} from '../../shared/authentication/roles/roles.service';
import {WindowService} from '../../shared/ui/window.service';
import {User, UserService} from '../../shared/user';

/**
 * Aside : the whole left navigation block, including the menu
 */
@Component({
  selector: '[gp-aside]',
  templateUrl: './aside.component.html',
  styleUrls: ['./aside.component.scss']
})
export class AsideComponent extends Destroyable implements OnInit {

  public user: User;
  public navLogoURL: string;

  constructor(public api: ApiService,
              public userService: UserService,
              public asideUtilsService: AsideUtilsService,
              public windowService: WindowService,
              private rolesService: RolesService) {
    super();
  }

  public ngOnInit() {
    this.userService.getUser()
      .pipe(
        tap(user => this.user = user),
        takeUntil(this.componentDestroyed$)
      )
      .subscribe();

    this.navLogoURL = this.windowService.isStaticImageAvailable('NAV_LOGO') ?
      `${this.api.file.prefix}/static/${this.windowService.getCliCoreNameFromHost()}/NAV_LOGO` : null;

    this.asideUtilsService.onNavLogoURLUpdated()
      .pipe(
        tap(navLogoURL => this.navLogoURL = navLogoURL),
        takeUntil(this.componentDestroyed$)
      )
      .subscribe();
  }
}
